import { graphql } from 'react-relay/legacy';
import commitMutation from 'relay-commit-mutation-promise';

const mutation = graphql`
    mutation checkoutRequestPasswordEmailMutation($input: CreatePasswordEmailInput!) {
        createPasswordEmail(input: $input) {
            message
        }
    }
`;

export function checkoutRequestPasswordEmailMutation(environment, { email, urlRedirect }) {
    return commitMutation(environment, {
        mutation,
        variables: {
            input: { email, urlRedirect },
        },
    });
}
